import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { EcommerceTermsProvider, useEcommerceTerms } from "@/integrations/wordpress/WordPressEcommerceTermsProvider";
import { WP_Term_Query } from "@/integrations/wordpress/wp_term_query";
const fallbackCategories = [{
  name: "HEAVY DUTY LINERS",
  description: "Industrial-grade thickness for construction and demolition waste management.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700859/img/heavy_duty_liners.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700859/img/heavy_duty_liners.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700859/img/heavy_duty_liners.png-wvc-sizes",
  link: "/GarbageBagsPage"
}, {
  name: "BIOHAZARD BAGS",
  description: "Certified medical waste solutions with reinforced seals and safety labeling.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700859/img/biohazard_bags.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700859/img/biohazard_bags.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700859/img/biohazard_bags.png-wvc-sizes",
  link: "/GarbageBagsPage"
}, {
  name: "DRAWSTRING TRASH",
  description: "High-tensile drawstring closures for efficient commercial facility maintenance.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700859/img/drawstring_trash.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700859/img/drawstring_trash.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700859/img/drawstring_trash.webp-wvc-sizes",
  link: "/GarbageBagsPage"
}, {
  name: "RECYCLING BAGS",
  description: "Color-coded blue and clear bags for streamlined waste segregation systems.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700859/img/recycling_bags.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700859/img/recycling_bags.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700859/img/recycling_bags.png-wvc-sizes",
  link: "/GarbageBagsPage"
}, {
  name: "COMPACTOR BAGS",
  description: "Extra-thick polymer construction designed to withstand high-pressure compaction.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700859/img/compactor_bags.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700859/img/compactor_bags.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700859/img/compactor_bags.png-wvc-sizes",
  link: "/GarbageBagsPage"
}, {
  name: "KITCHEN CAN LINERS",
  description: "Odor-control technology integrated into high-density polyethylene films.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700859/img/kitchen_liners.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700859/img/kitchen_liners.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700859/img/kitchen_liners.png-wvc-sizes",
  link: "/GarbageBagsPage"
}, {
  name: "OUTDOOR REFUSE",
  description: "UV-stabilized bags for municipal waste collection and landscaping projects.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700859/img/outdoor_refuse.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700859/img/outdoor_refuse.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700859/img/outdoor_refuse.png-wvc-sizes",
  link: "/GarbageBagsPage"
}, {
  name: "CLEAR POLY BAGS",
  description: "Transparent waste solutions for high-security environments and inventory visibility.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700859/img/clear_poly_bags.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700859/img/clear_poly_bags.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700859/img/clear_poly_bags.webp-wvc-sizes",
  link: "/GarbageBagsPage"
}, {
  name: "CONTRACTOR BAGS",
  description: "Puncture-resistant 3-mil thickness for sharp debris and heavy loads.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700859/img/contractor_bags.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700859/img/contractor_bags.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700859/img/contractor_bags.png-wvc-sizes",
  link: "/GarbageBagsPage"
}, {
  name: "CUSTOM PRINTED",
  description: "Bespoke branding and sizing for specialized industrial requirements.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700859/img/custom_printed_bags.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700859/img/custom_printed_bags.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700859/img/custom_printed_bags.png-wvc-sizes",
  link: "/CustomProductionPage"
}];
function AudioCategoriesConsumer() {
  const {
    terms,
    loading,
    error
  } = useEcommerceTerms();
  const staggerOffsets = ["md:mt-0", "md:mt-20", "md:mt-0", "md:mt-20", "md:mt-0", "md:mt-20", "md:mt-0", "md:mt-20", "md:mt-0", "md:mt-20"];
  const indices = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10"];
  if (loading) {
    return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3 md:gap-6">
        {[0, 1, 2, 3, 4, 5].map(i => <div key={i} data-index={i} className={`aspect-[3/4] bg-foreground/5 animate-pulse ${staggerOffsets[i] || ""}`} />)}
      </div>;
  }
  const displayCategories = !error && terms.length > 0 ? terms.slice(0, 10).map((term, i) => ({
    name: (term.name || "").toUpperCase(),
    description: term.description || fallbackCategories[i]?.description || "",
    image: term.image_url || fallbackCategories[i]?.image || "",
    srcset: term.image_url ? "" : fallbackCategories[i]?.srcset || "",
    sizes: term.image_url ? "" : fallbackCategories[i]?.sizes || "",
    link: term.link || fallbackCategories[i]?.link || "/GarbageBagsPage",
    isDynamic: !!term.image_url
  })) : fallbackCategories.map(c => ({
    ...c,
    isDynamic: false
  }));
  return <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-3 md:gap-6 lg:gap-8">
      {displayCategories.map((category, i) => <div key={i} data-index={i} className={`relative ${staggerOffsets[i] || ""} group`}>
          <Link to={category.link} className="block">
            <div className="relative aspect-[3/4] overflow-hidden bg-secondary shadow-lg transition-all duration-500 group-hover:-translate-y-1.5 group-hover:shadow-xl">
              {category.isDynamic ? <img src={category.image} alt={category.name} loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover transition-all duration-700 group-hover:grayscale" style={{
            filter: "grayscale(0.2) contrast(1.05)"
          }} /> : <img src={category.image} data-wvc-srcset={category.srcset} data-wvc-sizes={category.sizes} alt={category.name} loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover transition-all duration-700 group-hover:grayscale" />}

              <div className="absolute inset-0 bg-gradient-to-t from-foreground/90 via-foreground/10 to-transparent" />

              <div className="absolute top-5 left-5 font-mono text-xs tracking-widest text-background/90">
                {indices[i]}
              </div>

              <div className="absolute top-5 right-5 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <Button variant="primary" className="font-mono text-[10px] uppercase tracking-widest h-8 px-3 pointer-events-none">
                  {category.link.includes("Custom") ? "Request Quote" : "View Details"}
                  <ArrowRight className="ml-1.5 h-3 w-3" />
                </Button>
              </div>

              <div className="absolute bottom-0 left-0 right-0 p-5 sm:p-6">
                <h3 className="font-default font-bold text-2xl sm:text-3xl text-background leading-none tracking-tight">
                  <span className="relative inline-block">
                    {category.name}
                    <span className="absolute -bottom-1 left-0 h-1 w-0 bg-primary transition-all duration-500 group-hover:w-full" />
                  </span>
                </h3>
                <p className="mt-3 font-default text-sm text-background/85 leading-snug max-w-xs">
                  {category.description}
                </p>
              </div>
            </div>
          </Link>
        </div>)}
    </div>;
}
const wp_term_query_params = {
  taxonomy: "product_cat",
  per_page: 10,
  orderby: "count",
  order: "desc"
};
const wp_term_query = new WP_Term_Query(wp_term_query_params);
export default function CoreProductCategories() {
  return <section data-section-id="2280" id="core-product-categories" className="bg-background text-foreground py-24 md:py-32 px-5 sm:px-8 lg:px-12 relative overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between gap-4 pb-6 border-b border-border">
          <span className="font-mono text-[10px] sm:text-xs uppercase tracking-widest text-foreground">
            III / Manufacturing
          </span>
          <span className="font-mono text-[10px] sm:text-xs uppercase tracking-widest text-foreground">
            Catalog
          </span>
        </div>

        <div className="pt-10 md:pt-14 pb-16 md:pb-20">
          <h2 className="font-default font-black leading-[0.85] tracking-tighter text-foreground" style={{
          fontSize: "clamp(3rem, 8vw, 7rem)"
        }}>
            INDUSTRIAL
            <br />
            POLYMER SOLUTIONS.
          </h2>
        </div>

        <div className="relative">
          <EcommerceTermsProvider className="audio-categories-grid" wp_term_query={wp_term_query}>
            <AudioCategoriesConsumer />
          </EcommerceTermsProvider>

          <div aria-hidden="true" className="hidden lg:block absolute top-1/2 left-2/3 -translate-x-1/2 -translate-y-1/2 pointer-events-none z-10">
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-primary whitespace-nowrap" style={{
            transform: "rotate(90deg)"
          }}>
              Select Your / Specification
            </div>
          </div>
        </div>

        <div className="mt-24 md:mt-32 pt-6 border-t border-border flex items-center justify-between">
          <span className="font-mono text-[10px] sm:text-xs uppercase tracking-widest text-foreground">
            AKYASCO / Production
          </span>
          <span className="font-mono text-[10px] sm:text-xs uppercase tracking-widest text-primary">
            ● Bulk Wholesale Ready
          </span>
        </div>
      </div>
    </section>;
}